import React from 'react';
import Color from 'color';
import colors from '../../../styles/colors/index.module.scss';

interface Props {
  width?: number | string;
  startGradient?: string;
  endGradient?: string;
  className?: string;
}

export const BackgroundDecoration2: React.FC<Props> = ({
  width = 100,
  startGradient = colors.primary,
  endGradient = Color(colors.primary).lighten(0.5).hex(),
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 940 284"
    width={width}
    height={typeof width === 'number' ? width * (284 / 940) : 'auto'}
    className={className}
  >
    <mask
      id="a"
      width={940}
      height={284}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={startGradient}
        d="M0 0h940v284H0z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="url(#b)"
        d="M0 0h940v284H0z"
      />
      <g
        filter="url(#c)"
        opacity={0.5}
      >
        <path
          fill="url(#d)"
          d="M0 0h738.626L859 284H0V0Z"
        />
      </g>
      <g
        filter="url(#e)"
        opacity={0.5}
      >
        <path
          fill="url(#f)"
          d="M0 0h296.739L417 284H0V0Z"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={173.238}
        x2={241.979}
        y1={72.889}
        y2={323.488}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <linearGradient
        id="d"
        x1={158.31}
        x2={232.507}
        y1={72.889}
        y2={320.072}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <linearGradient
        id="f"
        x1={76.852}
        x2={197.382}
        y1={72.889}
        y2={267.816}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <filter
        id="c"
        width={882.6}
        height={307.6}
        x={-6.8}
        y={-11.8}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={5} />
        <feGaussianBlur stdDeviation={5.9} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_299_3026"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_299_3026"
          result="shape"
        />
      </filter>
      <filter
        id="e"
        width={460}
        height={327}
        x={-13.5}
        y={-21.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={8} />
        <feGaussianBlur stdDeviation={10.75} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_299_3026"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_299_3026"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
